enum LessonTypeEnum {
  PRACTICE = "Practice",
  INSTRUCTION = "Instruction"
}

export default LessonTypeEnum;
